import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ConfirmValidator(controlName: string, matchingControlName: string): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const formGroup = control as FormGroup;
		const firstControl = formGroup.get(controlName);
		const matchingControl = formGroup.get(matchingControlName);

		// Return null if controls are not found or if matchingControl already has other errors
		if (!firstControl || !matchingControl) {
			return null;
		}

		if (matchingControl.errors && !matchingControl.errors['confirmValidator']) {
			return null;
		}

		// Set error on matchingControl if values don't match
		if (firstControl.value !== matchingControl.value) {
			matchingControl.setErrors({ confirmValidator: true });
			return { confirmValidator: true };
		} else {
			matchingControl.setErrors(null);
			return null;
		}
	};
}
